import useApiGet from "hooks/api/useApiGet";
import AccountDto from "types/AccountDto";
import MultipleItemResponse from "types/MultipleItemResponse";
import endpoints from "./endpoints";

export interface Params {
  selfService?: boolean;
  suspendRequest?: boolean;
}

export default function useGetAccounts(params?: Params) {
  const result = useApiGet<MultipleItemResponse<AccountDto>>(
    params?.suspendRequest ? "" : endpoints.getAccounts(params ?? {}),
  );

  return {
    ...result,
    accounts: result.result?.dataList ?? [],
  };
}
